import { createContext, useContext } from 'react'

interface IDrawerContext {
	isOpen?: boolean
}

const DrawerContext = createContext<IDrawerContext>({})

export function useDrawerContext() {
	return useContext(DrawerContext)
}

export default DrawerContext.Provider
